// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AboutModalController from "./about_modal_controller"
application.register("about-modal", AboutModalController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import ApiKeyRevealController from "./api_key_reveal_controller"
application.register("api-key-reveal", ApiKeyRevealController)


import ApprovalActionsController from "./approval_actions_controller"
application.register("approval-actions", ApprovalActionsController)

import ApprovalSubmitController from "./approval_submit_controller"
application.register("approval-submit", ApprovalSubmitController)

import ApprovalWorkflows__ApproverSelectController from "./approval_workflows/approver_select_controller"
application.register("approval-workflows--approver-select", ApprovalWorkflows__ApproverSelectController)

import ApprovalWorkflows__RuleTesterController from "./approval_workflows/rule_tester_controller"
application.register("approval-workflows--rule-tester", ApprovalWorkflows__RuleTesterController)

import AttachmentItemController from "./attachment_item_controller"
application.register("attachment-item", AttachmentItemController)

import AttachmentsController from "./attachments_controller"
application.register("attachments", AttachmentsController)

import AutogrowController from "./autogrow_controller"
application.register("autogrow", AutogrowController)

import BackupCodesDownloadController from "./backup_codes_download_controller"
application.register("backup-codes-download", BackupCodesDownloadController)

import Bank__AccountPickerController from "./bank/account_picker_controller"
application.register("bank--account-picker", Bank__AccountPickerController)

import Bank__ConnectionController from "./bank/connection_controller"
application.register("bank--connection", Bank__ConnectionController)

import Bank__CrossCurrencySettlementController from "./bank/cross_currency_settlement_controller"
application.register("bank--cross-currency-settlement", Bank__CrossCurrencySettlementController)

import Bank__CsvMappingController from "./bank/csv_mapping_controller"
application.register("bank--csv-mapping", Bank__CsvMappingController)

import Bank__StatementEntriesController from "./bank/statement_entries_controller"
application.register("bank--statement-entries", Bank__StatementEntriesController)

import Bank__StatementFilterController from "./bank/statement_filter_controller"
application.register("bank--statement-filter", Bank__StatementFilterController)

import Bank__StatementImportController from "./bank/statement_import_controller"
application.register("bank--statement-import", Bank__StatementImportController)

import Bank__TransactionFilterController from "./bank/transaction_filter_controller"
application.register("bank--transaction-filter", Bank__TransactionFilterController)

import Bank__TransactionFilterMenuController from "./bank/transaction_filter_menu_controller"
application.register("bank--transaction-filter-menu", Bank__TransactionFilterMenuController)

import Bank__TransactionsOverviewController from "./bank/transactions_overview_controller"
application.register("bank--transactions-overview", Bank__TransactionsOverviewController)

import BankAccounts__BalanceTrendController from "./bank_accounts/balance_trend_controller"
application.register("bank-accounts--balance-trend", BankAccounts__BalanceTrendController)

import BankAccounts__DetectController from "./bank_accounts/detect_controller"
application.register("bank-accounts--detect", BankAccounts__DetectController)

import BankAccounts__PaymentMethodVisibilityController from "./bank_accounts/payment_method_visibility_controller"
application.register("bank-accounts--payment-method-visibility", BankAccounts__PaymentMethodVisibilityController)

import BankAccounts__SetDefaultController from "./bank_accounts/set_default_controller"
application.register("bank-accounts--set-default", BankAccounts__SetDefaultController)

import BetterStackController from "./better_stack_controller"
application.register("better-stack", BetterStackController)

import Billing__AddonPurchaseController from "./billing/addon_purchase_controller"
application.register("billing--addon-purchase", Billing__AddonPurchaseController)

import Billing__AddonQuantityController from "./billing/addon_quantity_controller"
application.register("billing--addon-quantity", Billing__AddonQuantityController)

import Billing__AutoBuyController from "./billing/auto_buy_controller"
application.register("billing--auto-buy", Billing__AutoBuyController)

import Billing__CheckoutController from "./billing/checkout_controller"
application.register("billing--checkout", Billing__CheckoutController)

import Billing__CouponController from "./billing/coupon_controller"
application.register("billing--coupon", Billing__CouponController)

import Billing__DowngradeKeepController from "./billing/downgrade_keep_controller"
application.register("billing--downgrade-keep", Billing__DowngradeKeepController)

import Billing__DowngradeSummaryController from "./billing/downgrade_summary_controller"
application.register("billing--downgrade-summary", Billing__DowngradeSummaryController)

import Billing__PlanChoiceModalController from "./billing/plan_choice_modal_controller"
application.register("billing--plan-choice-modal", Billing__PlanChoiceModalController)

import Billing__PricingStickyHeaderController from "./billing/pricing_sticky_header_controller"
application.register("billing--pricing-sticky-header", Billing__PricingStickyHeaderController)

import Billing__PricingToggleController from "./billing/pricing_toggle_controller"
application.register("billing--pricing-toggle", Billing__PricingToggleController)

import BrowserTabController from "./browser_tab_controller"
application.register("browser-tab", BrowserTabController)

import BsModalController from "./bs_modal_controller"
application.register("bs-modal", BsModalController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapseToggleController from "./collapse_toggle_controller"
application.register("collapse-toggle", CollapseToggleController)

import CommentController from "./comment_controller"
application.register("comment", CommentController)

import CompanyDetailsController from "./company_details_controller"
application.register("company-details", CompanyDetailsController)

import Contacts__DisclosureController from "./contacts/disclosure_controller"
application.register("contacts--disclosure", Contacts__DisclosureController)

import Contacts__ProvenanceController from "./contacts/provenance_controller"
application.register("contacts--provenance", Contacts__ProvenanceController)

import Contacts__RegisterDiffController from "./contacts/register_diff_controller"
application.register("contacts--register-diff", Contacts__RegisterDiffController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import DiagnosticEventController from "./diagnostic_event_controller"
application.register("diagnostic-event", DiagnosticEventController)

import DocumentFilterController from "./document_filter_controller"
application.register("document-filter", DocumentFilterController)

import DocumentGenerator__FormController from "./document_generator/form_controller"
application.register("document-generator--form", DocumentGenerator__FormController)

import Documents__CopyDocumentNumberController from "./documents/copy-document-number_controller"
application.register("documents--copy-document-number", Documents__CopyDocumentNumberController)

import Documents__CurrencyHandlerController from "./documents/currency_handler_controller"
application.register("documents--currency-handler", Documents__CurrencyHandlerController)

import Documents__DiffPreviewController from "./documents/diff_preview_controller"
application.register("documents--diff-preview", Documents__DiffPreviewController)

import Documents__DiscountController from "./documents/discount_controller"
application.register("documents--discount", Documents__DiscountController)

import Documents__DiscountToggleController from "./documents/discount_toggle_controller"
application.register("documents--discount-toggle", Documents__DiscountToggleController)

import Documents__DocumentUploadController from "./documents/document_upload_controller"
application.register("documents--document-upload", Documents__DocumentUploadController)

import Documents__DueDateSetterController from "./documents/due_date_setter_controller"
application.register("documents--due-date-setter", Documents__DueDateSetterController)

import Documents__ExchangeRateController from "./documents/exchange_rate_controller"
application.register("documents--exchange-rate", Documents__ExchangeRateController)

import Documents__ExtractionProposalCurrencyController from "./documents/extraction_proposal_currency_controller"
application.register("documents--extraction-proposal-currency", Documents__ExtractionProposalCurrencyController)

import Documents__FlowTimelineController from "./documents/flow_timeline_controller"
application.register("documents--flow-timeline", Documents__FlowTimelineController)

import Documents__ItemDescriptionController from "./documents/item-description_controller"
application.register("documents--item-description", Documents__ItemDescriptionController)

import Documents__ItemDiscountController from "./documents/item-discount_controller"
application.register("documents--item-discount", Documents__ItemDiscountController)

import Documents__ItemController from "./documents/item_controller"
application.register("documents--item", Documents__ItemController)

import Documents__ItemsCounterController from "./documents/items_counter_controller"
application.register("documents--items-counter", Documents__ItemsCounterController)

import Documents__ItemsManagerController from "./documents/items_manager_controller"
application.register("documents--items-manager", Documents__ItemsManagerController)

import Documents__MandatoryItemsController from "./documents/mandatory_items_controller"
application.register("documents--mandatory-items", Documents__MandatoryItemsController)

import Documents__MandatoryItemsLiveController from "./documents/mandatory_items_live_controller"
application.register("documents--mandatory-items-live", Documents__MandatoryItemsLiveController)

import Documents__MultiProformaPickerController from "./documents/multi_proforma_picker_controller"
application.register("documents--multi-proforma-picker", Documents__MultiProformaPickerController)

import Documents__NumberFormatController from "./documents/number_format_controller"
application.register("documents--number-format", Documents__NumberFormatController)

import Documents__OnPaymentRowController from "./documents/on_payment_row_controller"
application.register("documents--on-payment-row", Documents__OnPaymentRowController)

import Documents__PdfDownloadController from "./documents/pdf_download_controller"
application.register("documents--pdf-download", Documents__PdfDownloadController)

import Documents__PdfLocaleSyncController from "./documents/pdf_locale_sync_controller"
application.register("documents--pdf-locale-sync", Documents__PdfLocaleSyncController)

import Documents__QuickFiltersController from "./documents/quick_filters_controller"
application.register("documents--quick-filters", Documents__QuickFiltersController)

import Documents__ReverseChargeController from "./documents/reverse_charge_controller"
application.register("documents--reverse-charge", Documents__ReverseChargeController)

import Documents__SidebarController from "./documents/sidebar_controller"
application.register("documents--sidebar", Documents__SidebarController)

import Documents__StatusPanelController from "./documents/status_panel_controller"
application.register("documents--status-panel", Documents__StatusPanelController)

import Documents__TotalsCalculatorController from "./documents/totals_calculator_controller"
application.register("documents--totals-calculator", Documents__TotalsCalculatorController)

import Documents__TurnoverController from "./documents/turnover_controller"
application.register("documents--turnover", Documents__TurnoverController)

import Documents__VatPayerToggleController from "./documents/vat_payer_toggle_controller"
application.register("documents--vat-payer-toggle", Documents__VatPayerToggleController)

import Documents__VatRateWarningController from "./documents/vat_rate_warning_controller"
application.register("documents--vat-rate-warning", Documents__VatRateWarningController)

import DocumentsNumberUpdaterController from "./documents__number_updater_controller"
application.register("documents--number-updater", DocumentsNumberUpdaterController)

import EntityTypeToggleController from "./entity_type_toggle_controller"
application.register("entity-type-toggle", EntityTypeToggleController)

import Expenses__DocumentController from "./expenses/document_controller"
application.register("expenses--document", Expenses__DocumentController)

import Expenses__ExpenseTypeController from "./expenses/expense_type_controller"
application.register("expenses--expense-type", Expenses__ExpenseTypeController)

import Expenses__ExtractionStatusController from "./expenses/extraction_status_controller"
application.register("expenses--extraction-status", Expenses__ExtractionStatusController)

import Expenses__FilterController from "./expenses/filter_controller"
application.register("expenses--filter", Expenses__FilterController)

import Expenses__FilterMenuController from "./expenses/filter_menu_controller"
application.register("expenses--filter-menu", Expenses__FilterMenuController)

import Expenses__ImagePreviewController from "./expenses/image_preview_controller"
application.register("expenses--image-preview", Expenses__ImagePreviewController)

import Expenses__PdfPreviewController from "./expenses/pdf_preview_controller"
application.register("expenses--pdf-preview", Expenses__PdfPreviewController)

import Expenses__QrCodeReaderController from "./expenses/qr_code_reader_controller"
application.register("expenses--qr-code-reader", Expenses__QrCodeReaderController)

import Expenses__VatCalculationModeController from "./expenses/vat_calculation_mode_controller"
application.register("expenses--vat-calculation-mode", Expenses__VatCalculationModeController)

import Expenses__VatDeductionController from "./expenses/vat_deduction_controller"
application.register("expenses--vat-deduction", Expenses__VatDeductionController)

import ExportRangeSetterController from "./export_range_setter_controller"
application.register("export-range-setter", ExportRangeSetterController)

import ExtractionReviewController from "./extraction_review_controller"
application.register("extraction-review", ExtractionReviewController)

import FileExportAutodownloadController from "./file_export_autodownload_controller"
application.register("file-export-autodownload", FileExportAutodownloadController)

import FileExportRefreshController from "./file_export_refresh_controller"
application.register("file-export-refresh", FileExportRefreshController)

import FilterTabsController from "./filter_tabs_controller"
application.register("filter-tabs", FilterTabsController)

import FinanceManagement__BankAccountController from "./finance_management/bank_account_controller"
application.register("finance-management--bank-account", FinanceManagement__BankAccountController)

import FinanceManagement__DeadlineExtensionController from "./finance_management/deadline_extension_controller"
application.register("finance-management--deadline-extension", FinanceManagement__DeadlineExtensionController)

import FinanceManagement__DividendController from "./finance_management/dividend_controller"
application.register("finance-management--dividend", FinanceManagement__DividendController)

import FinanceManagement__GeneralSubmissionController from "./finance_management/general_submission_controller"
application.register("finance-management--general-submission", FinanceManagement__GeneralSubmissionController)

import FinanceManagement__SubmissionUploadController from "./finance_management/submission_upload_controller"
application.register("finance-management--submission-upload", FinanceManagement__SubmissionUploadController)

import FinanceManagement__TaxFormController from "./finance_management/tax_form_controller"
application.register("finance-management--tax-form", FinanceManagement__TaxFormController)

import FinanceManagement__VehicleTaxController from "./finance_management/vehicle_tax_controller"
application.register("finance-management--vehicle-tax", FinanceManagement__VehicleTaxController)

import ForecastToggleController from "./forecast_toggle_controller"
application.register("forecast-toggle", ForecastToggleController)

import Form__AutoSubmitController from "./form/auto_submit_controller"
application.register("form--auto-submit", Form__AutoSubmitController)

import Form__ConditionalFieldController from "./form/conditional_field_controller"
application.register("form--conditional-field", Form__ConditionalFieldController)

import Form__DestroyHandlerController from "./form/destroy_handler_controller"
application.register("form--destroy-handler", Form__DestroyHandlerController)

import Form__FileUploadController from "./form/file_upload_controller"
application.register("form--file-upload", Form__FileUploadController)

import Form__LogoPreviewController from "./form/logo_preview_controller"
application.register("form--logo-preview", Form__LogoPreviewController)

import Form__NumberParserController from "./form/number_parser_controller"
application.register("form--number-parser", Form__NumberParserController)

import Form__SingleSubmitController from "./form/single_submit_controller"
application.register("form--single-submit", Form__SingleSubmitController)

import Form__ToggleVisibilityController from "./form/toggle_visibility_controller"
application.register("form--toggle-visibility", Form__ToggleVisibilityController)

import Form__ValidationController from "./form/validation_controller"
application.register("form--validation", Form__ValidationController)

import GuideChecklistCardController from "./guide_checklist_card_controller"
application.register("guide-checklist-card", GuideChecklistCardController)

import GuideController from "./guide_controller"
application.register("guide", GuideController)

import HotkeyController from "./hotkey_controller"
application.register("hotkey", HotkeyController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import Insurances__FilterController from "./insurances/filter_controller"
application.register("insurances--filter", Insurances__FilterController)

import Insurances__FilterMenuController from "./insurances/filter_menu_controller"
application.register("insurances--filter-menu", Insurances__FilterMenuController)

import Insurances__PrefillInsuranceController from "./insurances/prefill_insurance_controller"
application.register("insurances--prefill-insurance", Insurances__PrefillInsuranceController)

import Insurances__QuickFiltersController from "./insurances/quick_filters_controller"
application.register("insurances--quick-filters", Insurances__QuickFiltersController)

import InvitationModalController from "./invitation_modal_controller"
application.register("invitation-modal", InvitationModalController)

import InviterTokenController from "./inviter_token_controller"
application.register("inviter-token", InviterTokenController)

import Invoices__SelectContactController from "./invoices/select_contact_controller"
application.register("invoices--select-contact", Invoices__SelectContactController)

import Invoices__SelectedContactController from "./invoices/selected_contact_controller"
application.register("invoices--selected-contact", Invoices__SelectedContactController)

import Invoices__ShowMoreController from "./invoices/show_more_controller"
application.register("invoices--show-more", Invoices__ShowMoreController)

import Invoices__TaxDocumentPickerController from "./invoices/tax_document_picker_controller"
application.register("invoices--tax-document-picker", Invoices__TaxDocumentPickerController)

import InvoicesFilterController from "./invoices_filter_controller"
application.register("invoices-filter", InvoicesFilterController)

import LegalEntityController from "./legal_entity_controller"
application.register("legal-entity", LegalEntityController)

import Loans__ExtractionStatusController from "./loans/extraction_status_controller"
application.register("loans--extraction-status", Loans__ExtractionStatusController)

import LogoController from "./logo_controller"
application.register("logo", LogoController)

import LogoFallbackController from "./logo_fallback_controller"
application.register("logo-fallback", LogoFallbackController)

import ManualPairingController from "./manual_pairing_controller"
application.register("manual-pairing", ManualPairingController)

import ModalCloserController from "./modal_closer_controller"
application.register("modal-closer", ModalCloserController)

import NavigateController from "./navigate_controller"
application.register("navigate", NavigateController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import NotificationsInfiniteScrollController from "./notifications_infinite_scroll_controller"
application.register("notifications-infinite-scroll", NotificationsInfiniteScrollController)

import NumberSeries__FormController from "./number_series/form_controller"
application.register("number-series--form", NumberSeries__FormController)

import NumberSeries__PickerController from "./number_series/picker_controller"
application.register("number-series--picker", NumberSeries__PickerController)

import NumberSeries__SanitizerController from "./number_series/sanitizer_controller"
application.register("number-series--sanitizer", NumberSeries__SanitizerController)

import NumberSeries__TypeSyncController from "./number_series/type_sync_controller"
application.register("number-series--type-sync", NumberSeries__TypeSyncController)

import Onboarding__AccountShowMoreController from "./onboarding/account_show_more_controller"
application.register("onboarding--account-show-more", Onboarding__AccountShowMoreController)

import Onboarding__CopyTextController from "./onboarding/copy_text_controller"
application.register("onboarding--copy-text", Onboarding__CopyTextController)

import Onboarding__ImportController from "./onboarding/import_controller"
application.register("onboarding--import", Onboarding__ImportController)

import Onboarding__ProgressController from "./onboarding/progress_controller"
application.register("onboarding--progress", Onboarding__ProgressController)

import Onboarding__ScrollRegionController from "./onboarding/scroll_region_controller"
application.register("onboarding--scroll-region", Onboarding__ScrollRegionController)

import Onboarding__TaxIdPendingController from "./onboarding/tax_id_pending_controller"
application.register("onboarding--tax-id-pending", Onboarding__TaxIdPendingController)

import Onboarding__TimeZoneController from "./onboarding/time_zone_controller"
application.register("onboarding--time-zone", Onboarding__TimeZoneController)

import OpenContactModalController from "./open_contact_modal_controller"
application.register("open-contact-modal", OpenContactModalController)

import OpenFetchModalController from "./open_fetch_modal_controller"
application.register("open-fetch-modal", OpenFetchModalController)

import OpenInvitationModalController from "./open_invitation_modal_controller"
application.register("open-invitation-modal", OpenInvitationModalController)

import OtpCountdownController from "./otp_countdown_controller"
application.register("otp-countdown", OtpCountdownController)

import OtpInputController from "./otp_input_controller"
application.register("otp-input", OtpInputController)

import OtpModeToggleController from "./otp_mode_toggle_controller"
application.register("otp-mode-toggle", OtpModeToggleController)

import PageTransitionController from "./page_transition_controller"
application.register("page-transition", PageTransitionController)

import PasskeyEnrollmentController from "./passkey_enrollment_controller"
application.register("passkey-enrollment", PasskeyEnrollmentController)

import PasskeyLoginController from "./passkey_login_controller"
application.register("passkey-login", PasskeyLoginController)

import PasskeyRegistrationController from "./passkey_registration_controller"
application.register("passkey-registration", PasskeyRegistrationController)

import PaymentFollowUpController from "./payment_follow_up_controller"
application.register("payment-follow-up", PaymentFollowUpController)

import Payments__PaymentOptionsController from "./payments/payment_options_controller"
application.register("payments--payment-options", Payments__PaymentOptionsController)

import PlaceholderHighlightController from "./placeholder_highlight_controller"
application.register("placeholder-highlight", PlaceholderHighlightController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import Realities__DocumentController from "./realities/document_controller"
application.register("realities--document", Realities__DocumentController)

import Realities__ExpandableController from "./realities/expandable_controller"
application.register("realities--expandable", Realities__ExpandableController)

import Realities__ExtractionStatusController from "./realities/extraction_status_controller"
application.register("realities--extraction-status", Realities__ExtractionStatusController)

import Realities__FilterController from "./realities/filter_controller"
application.register("realities--filter", Realities__FilterController)

import Realities__FilterMenuController from "./realities/filter_menu_controller"
application.register("realities--filter-menu", Realities__FilterMenuController)

import Realities__QuickFiltersController from "./realities/quick_filters_controller"
application.register("realities--quick-filters", Realities__QuickFiltersController)

import ReceivablesOverviewController from "./receivables_overview_controller"
application.register("receivables-overview", ReceivablesOverviewController)

import RecurringDocuments__GenerateNowController from "./recurring-documents/generate_now_controller"
application.register("recurring-documents--generate-now", RecurringDocuments__GenerateNowController)

import RecurringExpenses__ExtractionStatusController from "./recurring_expenses/extraction_status_controller"
application.register("recurring-expenses--extraction-status", RecurringExpenses__ExtractionStatusController)

import ReferralShareController from "./referral_share_controller"
application.register("referral-share", ReferralShareController)

import Rents__DocumentController from "./rents/document_controller"
application.register("rents--document", Rents__DocumentController)

import Rents__ExtractionStatusController from "./rents/extraction_status_controller"
application.register("rents--extraction-status", Rents__ExtractionStatusController)

import Reports__SurveyController from "./reports/survey_controller"
application.register("reports--survey", Reports__SurveyController)

import RoleMatrixController from "./role_matrix_controller"
application.register("role-matrix", RoleMatrixController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import SelectToFrameController from "./select_to_frame_controller"
application.register("select-to-frame", SelectToFrameController)

import SendEmailFormController from "./send_email_form_controller"
application.register("send-email-form", SendEmailFormController)

import Shared__DismissibleBannerController from "./shared/dismissible_banner_controller"
application.register("shared--dismissible-banner", Shared__DismissibleBannerController)

import SharedPasswordController from "./shared_password_controller"
application.register("shared-password", SharedPasswordController)

import SidebarTabsController from "./sidebar_tabs_controller"
application.register("sidebar-tabs", SidebarTabsController)

import SortableListController from "./sortable_list_controller"
application.register("sortable-list", SortableListController)

import SplitPanelController from "./split_panel_controller"
application.register("split-panel", SplitPanelController)

import SpotlightController from "./spotlight_controller"
application.register("spotlight", SpotlightController)

import AccessSwitchesController from "./access_switches_controller"
application.register("access-switches", AccessSwitchesController)

import SubmitButtonController from "./submit_button_controller"
application.register("submit-button", SubmitButtonController)

import TableFilterNavigationController from "./table_filter_navigation_controller"
application.register("table-filter-navigation", TableFilterNavigationController)

import TableInteractionsController from "./table_interactions_controller"
application.register("table-interactions", TableInteractionsController)

import TableNavigationController from "./table_navigation_controller"
application.register("table-navigation", TableNavigationController)

import TableSavedViewsController from "./table_saved_views_controller"
application.register("table-saved-views", TableSavedViewsController)

import TableSortController from "./table_sort_controller"
application.register("table-sort", TableSortController)

import ThemeSwitcherController from "./theme_switcher_controller"
application.register("theme-switcher", ThemeSwitcherController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleRowController from "./toggle_row_controller"
application.register("toggle-row", ToggleRowController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import Trips__FilterController from "./trips/filter_controller"
application.register("trips--filter", Trips__FilterController)

import Trips__IndexFilterController from "./trips/index_filter_controller"
application.register("trips--index-filter", Trips__IndexFilterController)

import Trips__SegmentsController from "./trips/segments_controller"
application.register("trips--segments", Trips__SegmentsController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import User__LanguageMenuController from "./user/language_menu_controller"
application.register("user--language-menu", User__LanguageMenuController)

import User__NotificationsChannelController from "./user/notifications_channel_controller"
application.register("user--notifications-channel", User__NotificationsChannelController)

import User__NotificationsController from "./user/notifications_controller"
application.register("user--notifications", User__NotificationsController)

import UserThemeController from "./user_theme_controller"
application.register("user-theme", UserThemeController)

import Vehicles__ExtractionStatusController from "./vehicles/extraction_status_controller"
application.register("vehicles--extraction-status", Vehicles__ExtractionStatusController)

import WelcomeController from "./welcome_controller"
application.register("welcome", WelcomeController)

import Workspaces__DocumentEmails__AutomationRulesController from "./workspaces/document_emails/automation_rules_controller"
application.register("workspaces--document-emails--automation-rules", Workspaces__DocumentEmails__AutomationRulesController)

import Workspaces__DocumentEmails__BccListController from "./workspaces/document_emails/bcc_list_controller"
application.register("workspaces--document-emails--bcc-list", Workspaces__DocumentEmails__BccListController)

import Workspaces__DocumentEmails__TemplateEditorController from "./workspaces/document_emails/template_editor_controller"
application.register("workspaces--document-emails--template-editor", Workspaces__DocumentEmails__TemplateEditorController)

import Workspaces__OudPreviewController from "./workspaces/oud_preview_controller"
application.register("workspaces--oud-preview", Workspaces__OudPreviewController)

import Workspaces__PrivatePersonController from "./workspaces/private_person_controller"
application.register("workspaces--private-person", Workspaces__PrivatePersonController)

import Workspaces__WorkspacePickerController from "./workspaces/workspace_picker_controller"
application.register("workspaces--workspace-picker", Workspaces__WorkspacePickerController)
